import { customAxios } from "@infrastructure/api/CustomAxios";
import { Endpoints } from "@config/Endpoints";
import { LanguageApiResponse } from "@resources/Language.apiResponse";
import { ListApiResponse } from "@infrastructure/api/List.apiResponse";

export const LanguageResource = {
  getLanguages: () => {
    return customAxios.get<ListApiResponse<LanguageApiResponse>>(
      Endpoints.languages.getLanguages
    );
  },
  updateLanguage: (languageId: string) => {
    return customAxios.patch(Endpoints.profile.setLanguage, { languageId });
  },
};
